module.exports = __webpack_public_path__ + "static/media/banner_4.1377c04a.jpg";